document.addEventListener('DOMContentLoaded', function() {
    var splide = new Splide('.information-banner-carousel', {
        type: 'fade',
        rewind: true,
        autoplay: true,
        interval: 3000,
        pagination: false,
        drag: false,
        speed: 1500,
        pauseOnHover: true,
        arrows: false,
    });
    splide.mount();
});